import { Switch, Route } from "react-router-dom";
import DataEntry from "./DataEntry/AddProperty";
import EditProperty from "./DataEntry/EditProperty";

function Support() {
    return (
        <Switch>
            <Route path="/dataentry">
                <DataEntry />
            </Route>
            <Route path="/editproperty">
                <EditProperty />
            </Route>
        </Switch>
    );
}

export default Support;